import {endpoints} from '@kapitalist/contract/endpoints'
import type {
  TPathPiecesOf,
  TRequestOf,
  TResponseOf,
} from '@kapitalist/contract/endpoints/types'
import type {TFormError} from '@kapitalist/contract/types'
import {PostApi} from '~/api/client'
import GetWaitingRoomData from '~/api/endpoints/game/PreGame/GetWaitingRoomData'

const endpoint = endpoints.pregame.joinGame

// TODO probably add something optional like `password?: string`?
type Params = TRequestOf<typeof endpoint>
type PathPieces = TPathPiecesOf<typeof endpoint>
export type TJoinGameResponse = TResponseOf<typeof endpoint>

/**
 * Join a game lobby before it begins.
 */
export default class JoinGame extends PostApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  protected mockRequestFailure(
    params: Params,
    pathPieces: PathPieces
  ): TFormError | null {
    if (pathPieces.maybeGameId === 'fail') {
      return {errors: {gameId: [`That game doesn't exist.`]}}
    }

    // return super.mockRequestFailure(params, pathPieces)
    return null // TODO replace this with defaultMockRequestFailure if/once we bring that behavior in from MW
  }

  protected getMockResponse(): TJoinGameResponse {
    GetWaitingRoomData.resetMockPlayerCount()
    return {}
  }

  protected transformResponse(r: TJoinGameResponse) {
    return r
  }
}
